export const toPathWhiteList = [
  '/resultBook', '/hometownAtlas', '/hometownAtlasDetail', '/peopleCongress20', '/partyLiving',
  '/partyLivingM3U8', '/filePrev', '/mobileIndex'
]
